@if (advertisement(); as ad) {
  <a
    class="relative my-10 block w-full md:my-14"
    [href]="ad.url"
    [target]="ad.newTab ? '_blank' : '_self'"
    rel="noopener noreferrer sponsored"
  >
    <!-- The grey band the artwork is drawn on: full width of the slot, while
         the artwork itself stays at its design size in the middle. Two of
         them, because each artwork puts its band at its own height. -->
    <span
      class="pointer-events-none absolute inset-x-0 bg-secondary-background md:hidden"
      [style.height.%]="mobileBand().height"
      [style.top.%]="mobileBand().top"
    ></span>
    <span
      class="pointer-events-none absolute inset-x-0 hidden bg-secondary-background md:block"
      [style.height.%]="desktopBand().height"
      [style.top.%]="desktopBand().top"
    ></span>
    <!-- `relative` is what keeps the artwork on top of the band: the band is
         positioned and would otherwise paint straight over it. -->
    <picture
      class="relative mx-auto block w-full max-w-[370px] md:max-w-[1220px]"
      [ngClass]="usesDesignBox() ? 'aspect-[370/308] md:aspect-[1220/420]' : ''"
    >
      <!-- Same 768px cut-off as Tailwind's `md:`, which the pages around this
           banner already switch their layout on, and which the sizes below
           switch on too. -->
      <source
        [attr.height]="ad.imageDesktop.height"
        [attr.width]="ad.imageDesktop.width"
        [srcset]="ad.imageDesktop.url"
        media="(min-width: 768px)"
      />
      <!-- width/height keep the image from shifting the page once it loads,
           and the max heights keep an artwork that was exported at the wrong
           proportions from stretching the page - `object-contain` scales it to
           fit instead of distorting it. The banner is a link, so it needs a
           name even when the advertiser left the alt text empty; "the
           internal title" would be the wrong one to borrow, hence the generic
           fallback. -->
      <img
        class="block max-h-[308px] w-full object-contain md:max-h-[420px]"
        [alt]="artworkAlt() ?? ('components.advertisement.alt' | translate)"
        [attr.height]="ad.imageMobile.height"
        [attr.width]="ad.imageMobile.width"
        [class.invisible]="artworkFailed()"
        [ngClass]="usesDesignBox() ? 'h-full' : 'h-auto'"
        [src]="ad.imageMobile.url"
        (error)="artworkFailed.set(true)"
        loading="lazy"
      />
    </picture>
  </a>
}
